import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/copyrightRegistration/HomeView.vue";
import Index from "../views/index.vue";
// import introduce from '../views/introduce.vue'
import instance from "../utils/request"; // 导入 instance
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const routes = [
  {
    path: "/",
    component: Index,
    children: [
      {
        path: "/",
        name: "introduce",
        component: () => import("../views/introduce/introduceNew.vue"),
        // component: () => import('../views/introduce/introduce.vue'),
        meta: {
          shovalues: true,
        },
      },
      // {
      //   path: '/home',
      //   name: 'home',
      //   component: HomeView
      // },
      {
        path: "/copyright",
        component: () => import("../views/copyrightRegistration/indexNew.vue"),
        children: [
          {
            path: "home",
            component: () =>
              import("../views/copyrightRegistration/HomeViewNew.vue"),
          },
          {
            path: "preservation",
            component: () => import("../views/preservaTion/HomeViewNew.vue"),
          },
          {
            path: "password",
            component: () =>
              import("../views/copyrightRegistration/passwordNew.vue"),
          },
          {
            path: "government",
            component: () =>
              import("../views/copyrightRegistration/government.vue"),
          },
          {
            path: "preservaTion",
            component: () => import("../views/preservaTion/index.vue"),
          },
        ],
      },
      {
        path: "/copyrighForm",
        component: () => import("../views/copyrightRegistration/index.vue"),
        children: [
          {
            path: "home",
            component: () =>
              import("../views/copyrightRegistration/HomeViewNew copy.vue"),
          },
          {
            path: "preservation",
            component: () => import("../views/preservaTion/HomeViewNew.vue"),
          },
          {
            path: "password",
            component: () =>
              import("../views/copyrightRegistration/passwordNew.vue"),
          },
          {
            path: "government",
            component: () =>
              import("../views/copyrightRegistration/government.vue"),
          },
          {
            path: "preservaTion",
            component: () => import("../views/preservaTion/index.vue"),
          },
        ],
      },
      {
        path: "/copyrightRegistration",
        name: "copyrightRegistration",
        component: () => import("../views/copyrightRegistration/AboutView.vue"),
      },
      {
        path: "/preservaRegistration",
        name: "preservaRegistration",
        component: () => import("../views/preservaTion/AboutView.vue"),
      },
      {
        path: "/registerList",
        name: "registerList",
        component: () => import("../views/register/registerList.vue"),
      },
      {
        path: "/register",
        name: "register",
        component: () => import("../views/register/register.vue"),
      },
      {
        path: "/registerGoods",
        name: "registerGoods",
        component: () => import("../views/register/registerGoods.vue"),
      },
      {
        path: "/transferenceList",
        name: "transferenceList",
        component: () => import("../views/transference/transferenceList.vue"),
      },
      {
        path: "/transference",
        name: "transference",
        component: () => import("../views/transference/transference.vue"),
      },
      {
        path: "/transferenceGoods",
        name: "transferenceGoods",
        component: () => import("../views/transference/transferenceGoods.vue"),
      },
      {
        path: "/submission",
        name: "submission",
        component: () =>
          import("@/views/assetIssuance/copyrightMint/submission.vue"),
        // meta: {
        //   shovalues: true,
        // },
      },
      {
        path: "/submissionStep",
        name: "submissionStep",
        component: () =>
          import("@/views/assetIssuance/copyrightMintnew/submissionStep.vue"),
        // meta: {
        //   shovalues: true,
        // },
      },
      {
        path: "/submissionSteps",
        name: "submissionSteps",
        component: () =>
          import(
            "@/views/assetIssuance/copyrightMintnew_v1/submissionStep.vue"
          ),
        // meta: {
        //   shovalues: true,
        // },
      },
      {
        path: "/login",
        name: "login",
        component: () => import("../views/login/login.vue"),
        meta: {
          shovalues: true,
        },
      },
      {
        path: "/newsList",
        name: "newsList",
        component: () => import("../views/introduce/newsList.vue"),
        meta: { shovalues: true },
      },
      {
        path: "/newsList_shop",
        name: "newsList_shop",
        component: () => import("../views/introduce/newsList_shop.vue"),
        meta: { shovalues: "1" },
      },
      {
        path: "/information",
        name: "information",
        component: () => import("../views/introduce/information.vue"),
        meta: { shovalues: true },
      },
      // 关于我们公告  未上线
      // {
      //   path: "/informationList",
      //   name: "informationList",
      //   component: () => import("../views/introduce/informationList.vue"),
      //   meta: { shovalues: true },
      // },
      {
        path: "/logon",
        name: "logon",
        component: () => import("../views/login/register.vue"),
        meta: {
          shovalues: true,
        },
      },
      {
        path: "/account",
        name: "account",
        component: () => import("../views/myAccount/index.vue"),
      },
      {
        path: "/addCard",
        name: "addCard",
        component: () => import("../views/myAccount/addCard/index.vue"),
      },
      {
        path: "/document",
        name: "document",
        // component: () => import('../views/preservaTion/introduce.vue'),
        component: () => import("../views//myAccount/document.vue"),
        meta: {
          shovalues: true,
        },
      },
      // 我的待办  未上线
      // {
      //   path: "/todoList",
      //   name: "todoList",
      //   component: () => import("../views/myAccount/todoList/todolist.vue"),
      // },
      {
        path: "/3dModelView",
        name: "3dModelView",
        // component: () => import('../views/preservaTion/introduce.vue'),
        component: () => import("../views/3dModelView/indexx.vue"),
        meta: {
          shovalues: true,
        },
      },
      {
        path: "/exitEvidence",
        name: "exitEvidence",
        component: () => import("../views/preservaTion/introduceNew.vue"),
        meta: {
          shovalues: true,
        },
      },
      {
        path: "/pre-registration",
        name: "pre-registration",
        component: () =>
          import("../views/copyrightRegistration/introduceNew1.vue"),
        // component: () => import('../views/copyrightRegistration/introduce.vue'),
        meta: {
          shovalues: true,
        },
      },
      {
        path: "/copyrightIssues",
        name: "copyrightIssues",
        component: () =>
          import("../views/copyrightRegistration/copyrightIssues.vue"),
      },
      {
        path: "/preservaTion",
        name: "preservaTion",
        component: () => import("../views/preservaTion/index.vue"),
      },
      {
        path: "/certificate",
        name: "certificate",
        component: () => import("../views/preservaTion/certificate.vue"),
      },
      {
        path: "/certificateDetails",
        name: "certificateDetails",
        component: () => import("../views/preservaTion/details.vue"),
      },
      {
        path: "/assetIssuance",
        component: () => import("../views/assetIssuance/index.vue"),
        children: [
          {
            path: "projectManage",
            component: () =>
              import("../views/assetIssuance/projectManage/index.vue"),
          },
          // 项目列表
          {
            path: "projectList",
            component: () =>
              import(
                "../views/assetIssuance/projectManage/projectList/projectList.vue"
              ),
          },
          // 项目信息
          // {
          //   path: "projectInfo",
          //   component: () =>
          //     import(
          //       "../views/assetIssuance/projectManage/projectList/projectInfo.vue"
          //     ),
          // },
          // 项目公告列表
          {
            path: "projectNotice",
            component: () =>
              import(
                "../views/assetIssuance/projectManage/projectNotice/projectNoticeList.vue"
              ),
          },
          // 项目公告详情
          {
            path: "projectNoticeDetail",
            component: () =>
              import(
                "../views/assetIssuance/projectManage/projectNotice/projectNoticeDetail.vue"
              ),
          },
          // 项目白皮书
          {
            path: "projectWhitePaper",
            component: () =>
              import(
                "../views/assetIssuance/projectManage/projectWhitePaper/projectWhitePaperList.vue"
              ),
          },
          // 项目动态
          {
            path: "projectDynamic",
            component: () =>
              import(
                "../views/assetIssuance/projectManage/projectDynamic/projectDynamicList.vue"
              ),
          },
          // 项目动态详情
          {
            path: "projectDynamicDetail",
            component: () =>
              import(
                "../views/assetIssuance/projectManage/projectDynamic/projectDynamicDetail.vue"
              ),
          },
          // 资产持有人
          {
            path: "projectListBearer",
            component: () =>
              import(
                "../views/assetIssuance/projectManage/projectList/projectListBearer.vue"
              ),
          },
          {
            path: "projectdetail",
            component: () =>
              import(
                "../views/assetIssuance/projectManage/projectList/projectdetail.vue"
              ),
          },
          // 项目权益
          {
            path: "projectInterests",
            component: () =>
              import(
                "../views/assetIssuance/projectManage/projectList/projectInterests.vue"
              ),
          },
          {
            path: "projectRights",
            component: () =>
              import(
                "../views/assetIssuance/projectManage/projectRights/projectRights.vue"
              ),
          },
          {
            path: "projectRightsDetails",
            component: () =>
              import(
                "../views/assetIssuance/projectManage/projectRights/projectRightsDetails.vue"
              ),
          },
          {
            path: "projectRightsDetail",
            component: () =>
              import(
                "../views/assetIssuance/projectManage/projectRights/projectRightsDetail.vue"
              ),
          },
          {
            path: "assetIssue",
            component: () => import("../views/assetIssuance/assetIssue.vue"),
          },
          {
            path: "newAssetCreate",
            component: () =>
              import("../views/assetIssuance/newAssetCreate.vue"),
          },
          {
            path: "newAssetCreatesw",
            component: () =>
              import("../views/assetIssuance/newAssetCreatesw.vue"),
          },
          {
            path: "addEdition",
            component: () => import("../views/assetIssuance/addEdition.vue"),
          },
          {
            path: "orderList",
            component: () =>
              import("../views/assetIssuance/orderList/index.vue"),
          },
          {
            path: "exerciseOrder",
            component: () =>
              import("../views/assetIssuance/orderList/exerciseOrder.vue"),
          },
          // 行权订单详情
          // {
          //   path: "exerciseOrderdetils",
          //   component: () =>
          //     import(
          //       "../views/assetIssuance/orderList/exerciseOrderdetils.vue"
          //     ),
          // },
          {
            path: "exerciseRecord",
            component: () =>
              import("../views/assetIssuance/orderList/exerciseRecord.vue"),
          },
          // 行权项目列表
          // {
          //   path: "itemList",
          //   component: () =>
          //     import("../views/assetIssuance/orderList/itemList.vue"),
          // },
          {
            path: "shelfList",
            component: () =>
              import("../views/assetIssuance/shelfList/shelfList.vue"),
          },
          // 行权统计
          // {
          //   path: "exerciseStatistics",
          //   component: () =>
          //     import("../views/assetIssuance/orderList/exerciseStatistics.vue"),
          // },
          // 行权统计明细
          // {
          //   path: "statisticalList",
          //   component: () =>
          //     import("../views/assetIssuance/orderList/statisticalList.vue"),
          // },
          // 划拨列表
          // {
          //   path: "transferdataList",
          //   component: () =>
          //     import("../views/assetIssuance/shelfList/transferdataList.vue"),
          // },
          {
            path: "whiteManagement",
            component: () =>
              import("../views/assetIssuance/whiteManagement/index.vue"),
          },
          {
            path: "whiteManagementUserList",  
            component: () =>
              import("../views/assetIssuance/whiteManagement/userList.vue"),
          },
          {
            path: "aftersalesList",
            component: () =>
              import("@/views/assetIssuance/aftersalesList/aftersalesList.vue"),
          },
          {
            path: "shelfDetails",
            component: () =>
              import("@/views/assetIssuance/shelfList/children/shelfDetails"),
          },
          {
            path: "onReleasesale",
            component: () =>
              import("@/views/assetIssuance/shelfList/children/onReleasesale"),
          },
          // 上架发行
          {
            path: "onIssue",
            component: () =>
              import("@/views/assetIssuance/shelfList/children/onIssue.vue"),
          },
          // 项目划拨
          {
            path: "projectTransfer",
            component: () =>
              import(
                "@/views/assetIssuance/shelfList/children/projectTransfer.vue"
              ),
          },
          // 项目划拨详情
          {
            path: "projectTransferDetail",
            component: () =>
              import(
                "@/views/assetIssuance/shelfList/children/projectTransferDetail.vue"
              ),
          },
          // 自持锁定
          {
            path: "selfLock",
            component: () =>
              import("@/views/assetIssuance/shelfList/children/selfLock.vue"),
          },
          // 自持锁定详情
          {
            path: "selfLockDetail",
            component: () =>
              import(
                "@/views/assetIssuance/shelfList/children/selfLockDetail.vue"
              ),
          },
          // 项目赠予
          {
            path: "bestow",
            component: () =>
              import("@/views/assetIssuance/shelfList/children/bestow.vue"),
          },
          // 项目赠予详情
          {
            path: "bestowDetail",
            component: () =>
              import(
                "@/views/assetIssuance/shelfList/children/bestowDetail.vue"
              ),
          },
          // 发行详情
          {
            path: "releaseDetails",
            component: () =>
              import(
                "@/views/assetIssuance/shelfList/children/releaseDetails.vue"
              ),
          },
          // 非公开发行
          {
            path: "privateProject",
            component: () =>
              import(
                "@/views/assetIssuance/shelfList/children/privateProject.vue"
              ),
          },
          // 非公开发行详情
          {
            path: "privateDetail",
            component: () =>
              import(
                "@/views/assetIssuance/shelfList/children/privateDetail.vue"
              ),
          },
          // 项目管理
          {
            path: "projectManagement",
            component: () =>
              import("@/views/assetIssuance/shelfList/projectManagement.vue"),
          },
          // 项目管理记录
          {
            path: "recordList",
            component: () =>
              import("@/views/assetIssuance/shelfList/recordList.vue"),
          },
          // 项目管理记录详情
          {
            path: "recordDetail",
            component: () =>
              import(
                "@/views/assetIssuance/shelfList/children/recordDetail.vue"
              ),
          },
          // 库存详情
          {
            path: "stockDetail",
            component: () =>
              import(
                "@/views/assetIssuance/shelfList/children/stockDetail.vue"
              ),
          },
          // 新增上架
          // {
          //   path: "newlyAdded",
          //   component: () =>
          //     import(
          //       "@/views/assetIssuance/shelfList/children/newlyAdded.vue"
          //     ),
          // },
          // 订单补录
          {
            path: "transferList",
            component: () =>
              import(
                "@/views/assetIssuance/shelfList/children/transferList.vue"
              ),
          },
          {
            path: "transferListRecord",
            component: () =>
              import(
                "@/views/assetIssuance/shelfList/children/transferListRecord.vue"
              ),
          },
          {
            path: "assetCommodity",
            component: () =>
              import("@/views/assetIssuance/assetCommodity/index.vue"),
          },
          // 实物发行
          {
            path: "assetCommoditysw",
            component: () =>
              import("@/views/assetIssuance/assetCommodity_sw/index.vue"),
          },
          {
            path: "proDuct",
            component: () => import("@/views/assetIssuance/proDuct/index.vue"),
          },
          {
            path: "products",
            component: () =>
              import("@/views/assetIssuance/proDuct/components/products.vue"),
          },
          {
            path: "proDuctaddEdition",
            component: () =>
              import("@/views/assetIssuance/proDuct/proDuctaddEdition.vue"),
          },
          // 版权铸造 三步审核
          // {
          //   path: "projectapplicationList",
          //   component: () =>
          //     import(
          //       "@/views/assetIssuance/copyrightMint/projectapplicationList.vue"
          //     ),
          // },
          {
            path: "copyrightMintList",
            component: () =>
              import(
                "@/views/assetIssuance/copyrightMint/copyrightMintlist.vue"
              ),
          },
          // {
          //   path: "submission",
          //   component: () =>
          //     import("@/views/assetIssuance/copyrightMint/submission.vue"),
          // },
          // 版权铸造新
          {
            path: "projectapplicationLists",
            component: () =>
              import(
                "@/views/assetIssuance/copyrightMintnew/projectapplicationList.vue"
              ),
          },
          {
            path: "copyrightMintLists",
            component: () =>
              import(
                "@/views/assetIssuance/copyrightMintnew/copyrightMintlist.vue"
              ),
          },
          // 版权铸造新9月
          // {
          //   path: "projectapplicationListnew",
          //   component: () =>
          //     import(
          //       "@/views/assetIssuance/copyrightMintnews/projectapplicationList.vue"
          //     ),
          // },
          {
            path: "projectapplicationListnew",
            component: () =>
              import(
                "@/views/assetIssuance/copyrightMintnew_v1/projectapplicationList.vue"
              ),
          },
          // 批次管理列表
          {
            path: "castingManagement",
            component: () =>
              import(
                "@/views/assetIssuance/copyrightMintnew_v1/castingManagement.vue"
              ),
          },
          // 批次管理详情
          {
            path: "castingManagementdetils",
            component: () =>
              import(
                "@/views/assetIssuance/copyrightMintnew_v1/castingManagementdetils.vue"
              ),
          },
          // 权益方管理
          //权益方申请审核
          {
            path: "equityReceiver",
            component: () =>
              import(
                "@/views/assetIssuance/equityStakeholder/equityReceiver.vue"
              ),
          },
          //第三方权益方
          {
            path: "equityHolder",
            component: () =>
              import(
                "@/views/assetIssuance/equityStakeholder/equityHolder.vue"
              ),
          },
          //权益方审核
          {
            path: "equityHolder",
            component: () =>
              import(
                "@/views/assetIssuance/equityStakeholder/rightsReview.vue"
              ),
          },
          // 权益管理
          {
            path: "rightsReview",
            component: () =>
              import(
                "@/views/assetIssuance/equityStakeholder/rightsReview.vue"
              ),
          },
          // 第三方权益审核
          {
            path: "thirdpartyRights",
            component: () =>
              import(
                "@/views/assetIssuance/equityStakeholder/thirdpartyRights.vue"
              ),
          },
          // 第三方权益审核详情
          {
            path: "reviewDetails",
            component: () =>
              import(
                "@/views/assetIssuance/equityStakeholder/reviewDetails.vue"
              ),
          },
          // 权益方申请审核详情
          {
            path: "equityReceiverDetails",
            component: () =>
              import(
                "@/views/assetIssuance/equityStakeholder/equityreviewDetails.vue"
              ),
          },
          // 权益项信息
          {
            path: "equityItem",
            component: () =>
              import("@/views/assetIssuance/equityStakeholder/equityItem.vue"),
          },
          // 申请成为权益方
          {
            path: "applytoStakeholder",
            component: () =>
              import(
                "@/views/assetIssuance/equityStakeholder/applytoStakeholder.vue"
              ),
          },
          // 新增权益项
          {
            path: "newequityItems",
            component: () =>
              import(
                "@/views/assetIssuance/equityStakeholder/newequityItems.vue"
              ),
          },
          // 权益中心  未上线
          // 自有权益
          // {
          //   path: "equityInterest",
          //   component: () =>
          //     import(
          //       "@/views/assetIssuance/equityCenter/equityInterest.vue"
          //     ),
          // },
          // // 自有权益新增权益
          // {
          //   path: "newEquityInterest",
          //   component: () =>
          //     import(
          //       "@/views/assetIssuance/equityCenter/newEquityInterest.vue"
          //     ),
          // },
          // // 权益中心商品管理
          // {
          //   path: "goodsManagement",
          //   component: () =>
          //     import(
          //       "@/views/assetIssuance/equityCenter/goodsManagement.vue"
          //     ),
          // },
          // // 新增权益商品
          // {
          //   path: "newequitygoods",
          //   component: () =>
          //     import(
          //       "@/views/assetIssuance/equityCenter/newequityGoods.vue"
          //     ),
          // },
          // // 自有权益管理
          // {
          //   path: "equitygoodsManagement",
          //   component: () =>
          //     import(
          //       "@/views/assetIssuance/equityCenter/equitygoodsManagement.vue"
          //     ),
          // },
          // //项目权益
          // //列表
          // {
          //   path: "projectEquity",
          //   component: () =>
          //     import(
          //       "@/views/assetIssuance/equityCenter/projectEquity/projectEquity.vue"
          //     ),
          // },
          // // 新权益管理列表
          // {
          //   path: "rightsReviewcenter",
          //   component: () =>
          //     import(
          //       "@/views/assetIssuance/equityCenter/projectEquity/rightsReview.vue"
          //     ),
          // },
          // // 申请成为权益方
          // {
          //   path: "applytoStakeholdercenter",
          //   component: () =>
          //     import(
          //       "@/views/assetIssuance/equityCenter/projectEquity/applytoStakeholder.vue"
          //     ),
          // },
          // // 权益详情
          // // 项目权益详情
          // {
          //   path: "projectEquityDetails",
          //   component: () =>
          //     import(
          //       "@/views/assetIssuance/equityCenter/projectEquity/projectEquityDetails.vue"
          //     ),
          // },
          // // 第三方权益审核
          // {
          //   path: "thirdpartyRightscenter",
          //   component: () =>
          //     import(
          //       "@/views/assetIssuance/equityCenter/rightsReview/thirdpartyRights.vue"
          //     ),
          // },
          // // 第三方权益审核详情
          // {
          //   path: "thirdpartyRightsDetails",
          //   component: () =>
          //     import(
          //       "@/views/assetIssuance/equityCenter/rightsReview/thirdpartyRightsDetails.vue"
          //     ),
          // },
          // // 第三方权益
          // {
          //   path: "equityInterestcenter",
          //   component: () =>
          //     import(
          //       "@/views/assetIssuance/equityCenter/rightsInterests/equityInterest.vue"
          //     ),
          // },
          // // 第三方权益管理
          // {
          //   path: "equitygoodsManagementcenter",
          //   component: () =>
          //     import(
          //       "@/views/assetIssuance/equityCenter/rightsInterests/equitygoodsManagement.vue"
          //     ),
          // },
        ],
      },
      {
        path: "/assetManagement",
        component: () => import("../views/assetManagement/index.vue"),
        children: [
          {
            path: "assetsCopyright",
            component: () =>
              import("../views/assetManagement/assetsCopyright.vue"),
          },
          {
            path: "assetsRealRight",
            component: () =>
              import("../views/assetManagement/assetsRealRight.vue"),
          },
          {
            path: "copyrightRegister",
            component: () =>
              import("../views/assetManagement/copyrightRegister.vue"),
          },
          {
            path: "authorizationAssets",
            component: () =>
              import("../views/assetManagement/authorizationAssets.vue"),
          },
          {
            path: "transferAssets",
            component: () =>
              import("../views/assetManagement/transferAssets.vue"),
          },
          {
            path: "workRegistration",
            component: () =>
              import("../views/assetManagement/workRegistration.vue"),
          },
          {
            //资产管理-资产详情
            path: "assetsDetail",
            component: () =>
              import("../views/assetManagement/children/assetsDetail.vue"),
          },
        ],
      },
      {
        path: "/solution",
        component: () => import("../views/solution/index.vue"),
        children: [
          {
            path: "arTregistration",
            component: () => import("../views/solution/arTregistration.vue"),
          },
          {
            path: "iteMregistration",
            component: () => import("../views/solution/iteMregistration.vue"),
          },
          {
            path: "newRealinput",
            component: () => import("../views/solution/newRealinput.vue"),
          },
          {
            path: "goodsRegister",
            component: () => import("../views/solution/goodsRegister.vue"),
          },
          // {
          //   path: 'shelfList',
          //   component: () => import('../views/assetIssuance/shelfList/shelfList.vue'),
          // }, {
          //   path: 'shelfDetails',
          //   component: () => import('@/views/assetIssuance/shelfList/children/shelfDetails')
          // }, {
          //   path: 'assetCommodity',
          //   component: () => import('@/views/assetIssuance/assetCommodity/index.vue')
          // }
        ],
      },
      {
        path: "/book",
        component: () => import("../views/book/indxe.vue"),
        children: [
          {
            path: "newbookRelease",
            component: () => import("../views/book/newbookRelease.vue"),
          },
          {
            path: "oldbookDistribution",
            component: () => import("../views/book/oldbookDistribution.vue"),
          },
          {
            path: "newAssetCreate",
            component: () => import("../views/book/newAssetCreate.vue"),
          },
          {
            path: "addEdition",
            component: () => import("../views/book/addEdition.vue"),
          },
          // {
          //   path: 'shelfList',
          //   component: () => import('../views/assetIssuance/shelfList/shelfList.vue'),
          // },
          // {
          //   path: 'shelfDetails',
          //   component: () => import('@/views/assetIssuance/shelfList/children/shelfDetails')
          // },
          // {
          //   path: 'assetCommodity',
          //   component: () => import('@/views/assetIssuance/assetCommodity/index.vue')
          // }
        ],
      },
      {
        path: "/activity",
        component: () => import("../views/activity/indxe.vue"),
        children: [
          {
            path: "/activity/activityList",
            component: () => import("../views/activity/HomeView1.vue"),
          },
          {
            path: "/activity/activity-create",
            component: () => import("../views/activity/activity-create.vue"),
          },
          {
            path: "/activity/certificateManagement",
            component: () =>
              import(
                "../views/activity/certificateManagement/certificateList.vue"
              ),
          },
          {
            path: "/activity/certificateStatistics",
            component: () =>
              import(
                "../views/activity/certificateStatistics/certificateList.vue"
              ),
          },
          {
            path: "/activity/checkRegistration",
            component: () =>
              import(
                "../views/activity/certificateStatistics/checkRegistration.vue"
              ),
          },
        ],
      },
      {
        path: "/copyrightDetail",
        name: "copyrightDetail",
        component: () =>
          import("../views/assetManagement/children/copyrightDetail.vue"),
      },
      {
        path: "/verification",
        name: "verification",
        component: () =>
          import("../views/assetManagement/children/verification.vue"),
      },
      {
        path: "/egistrationDetails",
        name: "egistrationDetails",
        component: () =>
          import("../views/assetManagement/children/egistrationDetails.vue"),
      },
      {
        path: "/copyList",
        name: "copyList",
        component: () => import("../views/assetIssuance/copyList.vue"),
      },
      {
        path: "/copyDetails",
        name: "copyDetails",
        component: () => import("../views/assetIssuance/copyDetails.vue"),
      },
      {
        path: "/nodeAccess",
        name: "nodeAccess",
        component: () => import("../views/nodeAccess/index.vue"),
        meta: {
          shovalues: true,
        },
      },
      {
        path: "/sale",
        name: "sale",
        component: () => import("../views/sale"),
        meta: { shovalues: "1" },
      },
      {
        path: "/joinUs",
        name: "joinUs",
        component: () => import("../views/sale/join.vue"),
        meta: { shovalues: "1" },
      },
      {
        path: "/saleList",
        name: "saleList",
        component: () => import("../views/sale/saleList.vue"),
        meta: { shovalues: "1" },
      },
      {
        path: "/saleList1",
        name: "saleList1",
        component: () => import("../views/sale/saleList1.vue"),
        meta: { shovalues: "1" },
      },
      {
        path: "/saleDetails",
        name: "saleDetails",
        component: () => import("../views/sale/saleDetails.vue"),
        meta: { shovalues: "1" },
      },
      {
        path: "/orderDetails",
        name: "orderDetails",
        component: () => import("../views/asset/orderDetails.vue"),
        meta: { shovalues: "1" },
      },
      {
        path: "/payDetails",
        name: "payDetails",
        component: () => import("../views/asset/payDetails.vue"),
        meta: { shovalues: "1" },
      },
      {
        path: "/payResult",
        name: "payResult",
        component: () => import("../views/asset/payResult.vue"),
        meta: { shovalues: "1" },
      },
      // {
      //   path: '/transaction',
      //   name: 'transaction',
      //   component: () => import('../views/asset/transaction.vue'),
      //   meta: { shovalues: '1' }
      // },
      {
        path: "*",
        component: () => import("../views/404.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

// 监听路由变化
router.afterEach(() => {
  // 定义 getBaseURL 函数
  // function getBaseURL() {
  //   const path = window.location.pathname;
  //   if (path.includes("/projectList") || path.includes("/projectdetail")) {
  //     return process.env.VUE_APP_BASE_API_1;
  //   } else {
  //     return process.env.VUE_APP_BASE_API_2;
  //   }
  // }
  // 路由变化后重新计算 baseURL
  // const newBaseURL = getBaseURL();
  // 更新 axios 实例的 baseURL
  // instance.defaults.baseURL = newBaseURL;
});

export default router;
